import './external-tools';
import initializeFoundation from './foundation';
import { initializeAnalytics } from './initializeAnalytics';
import initializeNestedFields from './nestedFields';
import initializeRailsFormValidation from './railsFormValidation';
import initializeReveal from './reveal';
import './setupDatadog';
import './setupHoneybadger';
import initializeStickySidebar from './stickySidebar';
import initializeTooltips from './tooltip';
import initializeTopbar from './topbar';
import './whatInput';
import { onReady } from 'boot/common/domReady';

onReady(initializeAnalytics);

onReady(initializeFoundation);
onReady(initializeStickySidebar);
onReady(initializeTooltips);
onReady(initializeRailsFormValidation);
onReady(initializeNestedFields);
onReady(initializeReveal);
onReady(initializeTopbar);
